
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seguranca",
      function () {
        return require("private-next-pages/seguranca.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seguranca"])
      });
    }
  